module.exports = __webpack_public_path__ + "img/cabeca_pit.7dbc24a2.png";